import { render, staticRenderFns } from "./Syfw.vue?vue&type=template&id=15cde186&scoped=true"
import script from "./Syfw.vue?vue&type=script&lang=js"
export * from "./Syfw.vue?vue&type=script&lang=js"
import style0 from "./Syfw.vue?vue&type=style&index=0&id=15cde186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cde186",
  null
  
)

export default component.exports